import React from 'react';
import { default as Page } from '@atlaskit/pagination';
import range from 'lodash/range';
import styles from 'componets/pagination/index.module.scss';
import classname from 'classnames/bind';
import iconArrow from 'images/icon-pagination-next.svg';
import iconArrowDisable from 'images/icon-pagination-next-disable.svg';
import iconEllipsis from 'images/icon-pagination-ellipsis.svg';

const cx = classname.bind(styles);

const Pagination = ({ currentPage, totalPage, onPageSelected }) => {
  const pageItem = props => {
    const pageClasses = cx({
      page: true,
      active: currentPage === props.page,
    });
    return (
      <div className={pageClasses} onClick={props.onClick}>
        {props.page}
      </div>
    );
  };

  const pageNext = props => {
    const disable = currentPage === totalPage;
    const icon = disable ? iconArrowDisable : iconArrow;
    const onClick = disable ? undefined : props.onClick;
    const nextClasses = cx({
      arrow: true,
      disable,
    });
    return <img className={nextClasses} src={icon} alt="next" onClick={onClick} />;
  };

  const pagePrevious = props => {
    const disable = currentPage === 1;
    const icon = disable ? iconArrowDisable : iconArrow;
    const onClick = disable ? undefined : props.onClick;
    const previousClasses = cx({
      arrow: true,
      previous: true,
      disable,
    });
    return <img className={previousClasses} src={icon} alt="previous" onClick={onClick} />;
  };

  const pageEllipsis = () => {
    return <img src={iconEllipsis} alt="ellipsis" />;
  };

  // current page or total page 小於 0 都是異常狀態
  // 目前篩選不到資料時 api total page 會給 0 所以當其一小於 0 則隱藏分頁
  if (currentPage <= 0 || totalPage <= 0) {
    return <></>;
  }

  return (
    <Page
      max={8}
      pages={range(1, totalPage + 1)}
      onChange={(event, newPage) => onPageSelected(newPage)}
      selectedIndex={currentPage - 1}
      renderEllipsis={pageEllipsis}
      components={{
        Page: pageItem,
        Previous: pagePrevious,
        Next: pageNext,
      }}
    />
  );
};

export default Pagination;
